var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3256 18C5.90731 18 2.32559 14.4183 2.32559 10C2.32559 5.58172 5.90731 2 10.3256 2C14.7439 2 18.3256 5.58172 18.3256 10C18.3256 14.4183 14.7439 18 10.3256 18ZM9.32559 8.9996C9.32559 9.55188 9.77331 9.9996 10.3256 9.9996C10.8779 9.9996 11.3256 9.55188 11.3256 8.9996V6.9996C11.3256 6.44732 10.8779 5.9996 10.3256 5.9996C9.77331 5.9996 9.32559 6.44732 9.32559 6.9996V8.9996ZM9.32559 12.9996C9.32559 13.5519 9.77331 13.9996 10.3256 13.9996C10.8779 13.9996 11.3256 13.5519 11.3256 12.9996C11.3256 12.4473 10.8779 11.9996 10.3256 11.9996C9.77331 11.9996 9.32559 12.4473 9.32559 12.9996Z",
    fill: "#AB201F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationWarning);
export default __webpack_public_path__ + "static/media/ExclamationWarning.cc3ead479d1a00c3fae5b8bf4e5fd619.svg";
export { ForwardRef as ReactComponent };